import React from 'react';

import {
  Labeled,
  required,
  SelectInput,
  TextInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import CreateDialog from '../layout/dialog/CreateDialog';

import useRequestTypesChoices from '../../hooks/useRequestTypesChoices';

const ProcessCreate = () => {
  const { choices } = useRequestTypesChoices();

  return (
    <CreateDialog title="processes">
      <Grid container spacing={6}>
        <Grid size={12}>
          <Labeled label="Name">
            <TextInput fullWidth validate={required()} source="name" label="" helperText={false} />
          </Labeled>
        </Grid>
        <Grid size={12}>
          <Labeled label="Request type">
            <SelectInput
              source="requestType"
              label=""
              choices={choices}
              validate={required()}
              helperText={false}
            />
          </Labeled>
        </Grid>
      </Grid>
    </CreateDialog>

  );
};

export default ProcessCreate;
